var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReceiptDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9203 1C11.9203 1.44083 11.584 1.80425 11.1485 1.85831H10.9233C10.4878 1.80425 10.1515 1.44083 10.1515 1H8.38263C8.38263 1.44083 8.04634 1.80425 7.61084 1.85831H7.38558C6.95008 1.80425 6.61379 1.44083 6.61379 1H4.84494C4.84494 1.44083 4.50865 1.80425 4.07315 1.85831H3.84789C3.41239 1.80425 3.07609 1.44083 3.07609 1H1.315V2.36619H1.32395V2.71218V8.90716H0V14H15V8.90716H13.6827V2.71218V1.85831H13.6814V1H11.9203ZM3.04151 3.56605V10.6487H11.9652V3.56605H3.04151Z",
    fill: "#CCCFD1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 6.5H10V8H5V6.5Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReceiptDisable);
export default __webpack_public_path__ + "static/media/icon-receipt-disable.fd2ffc8dd8291a3e3a1cca43c3b8ddc2.svg";
export { ForwardRef as ReactComponent };